module.exports = __webpack_public_path__ + "static/img/yemian-bg.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yemian-bg.png
// module id = 107
// module chunks = 0